"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../../../../hooks");
exports.NewEmailSubmitButton = ({ state: { templateVersion, name }, isDisabled, }) => {
    const { mutate, mutationResult } = hooks_1.useCreateEmailServerSide({
        name,
        openOnCreate: true,
        templateVersion,
    });
    return (react_1.default.createElement(react_2.OsmosysDiv, { className: "d-flex" },
        react_1.default.createElement(react_2.OsmosysButton, { osysName: "NewEmailSubmitButton", osysIcon: "arrowRight", iconPosition: "right", color: "success", mutate: mutate, disabled: isDisabled, mutationResult: mutationResult, renderApolloError: true }, "Create email")));
};
//# sourceMappingURL=NewEmailSubmitButton.js.map